import { useState } from "react";
import { Alert, Button, Input } from "reactstrap";
import FileDnd from "../../../../components/FormBuilder/CustomizationTab/BuildTab/components/FileDnd";
import AppSpinner from "../../../../elements/AppSpinner";
import useAskYourPDF from "../../../../api/api-hooks/brie/AskYourPDF/useAskYourPDF";
import IconButton from "../../../../elements/IconButton";
import AppCopy from "../../../../components/AppComponents/AppCopy";

const AskYourPDF = () => {
  const [uploadedFile, setUploadedFile] = useState<any>();
  const [query, setQuery] = useState("");
  const [resultQuestion, setResultQuestion] = useState("");
  const [result, setResult] = useState("");

  const {
    canChat,
    uploadPDF,
    queryPDF,
    deletePDF,
    uploading,
    querying,
    error,
  } = useAskYourPDF();

  const clear = () => {
    setQuery("");
    setResult("");
    setResultQuestion("");
  };

  const handleRemoveFile = () => {
    setUploadedFile(undefined);
    clear();
    deletePDF();
  };

  const handleUploadFile = (e: any) => {
    const file = e.target.files[0];

    setUploadedFile(file);
    uploadPDF(file, () => {
      setUploadedFile(undefined);
      clear();
    });
  };

  const handleGetData = async () => {
    if (!canChat || !query) return;

    const result = await queryPDF(query, () => setUploadedFile(undefined));

    setResult(result);
    setResultQuestion(query);
    setQuery("");
  };

  return (
    <>
      <div
        className="d-flex flex-column"
        style={{
          boxShadow: "0px 1px 8px 2px rgba(0, 0, 0, 0.15)",
          padding: "24px",
          borderRadius: "8px",
          width: "100%",
        }}
      >
        <div className="d-flex w-100 align-items-center mb-3">
          <i
            className="mdi mdi-account-question mr-3"
            style={{ fontSize: "32px" }}
          ></i>
          <h2 className="m-0">Ask Your PDF</h2>
        </div>
        <p
          className="m-0 mb-1"
          style={{
            fontSize: "13px",
            fontWeight: 400,
            letterSpacing: "0.0025em",
          }}
        >
          Upload your PDF and input your question to retrieve the required
          information from the document.
        </p>
        <span className="font-weight-bold text-sm my-3">Upload a PDF</span>

        {uploadedFile ? (
          <div
            className="d-flex w-100 p-2 align-items-center"
            style={{ backgroundColor: "#F0F3F2" }}
          >
            <i
              className="mdi mdi-file-document-outline mr-2"
              style={{ fontSize: "25px" }}
            />
            <span>{uploadedFile.name}</span>
            {uploading && <AppSpinner size="md" className="ml-auto" />}
            {canChat && (
              <IconButton
                icon="close"
                onClick={handleRemoveFile}
                color="danger"
                className="ml-auto"
                disabled={querying}
              />
            )}
          </div>
        ) : (
          <FileDnd
            upload={handleUploadFile}
            uploading={uploading}
            accept="application/pdf"
          />
        )}

        {canChat && (
          <div className="d-flex flex-column">
            <span className="font-weight-bold text-sm mt-4 mb-2">
              Ask a question about your PDF
            </span>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleGetData();
              }}
            >
              <Input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Ex. What are the financial projections for the next quarter mentioned in the PDF?"
                disabled={querying}
              />
            </form>

            <div className="mt-3 ml-auto">
              {querying ? (
                <AppSpinner className="ml-auto" size="md" />
              ) : (
                <>
                  <Button
                    onClick={clear}
                    size="sm"
                    className="m-0 p-0 mr-3"
                    outline
                    style={{
                      width: "65px",
                      height: "32px",
                      marginLeft: "10px",
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    onClick={handleGetData}
                    color="primary"
                    size="sm"
                    className="m-0 p-0"
                    style={{
                      width: "90px",
                      height: "32px",
                      marginLeft: "10px",
                    }}
                  >
                    Ask PDF
                  </Button>
                </>
              )}
            </div>
          </div>
        )}

        {error && (
          <Alert color="danger" className="mt-4">
            {error}
          </Alert>
        )}

        {resultQuestion && canChat && !error && (
          <div className="d-flex align-items-center mt-3">
            <div className="font-weight-bold mr-2 text-light">Question:</div>
            <div className="text-dark font-weight-500">{resultQuestion}</div>
          </div>
        )}
        {result && (
          <div className="d-flex flex-column mt-3">
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-primary font-weight-bold mt-1">
                Answer:
              </span>
              <AppCopy text={result} />
            </div>
            <p className="mt-2 bg-ultralight text-dark p-2 border border-superlight rounded-sm">
              {result}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default AskYourPDF;
